import { environmentService, userService, postRequestHandler } from "@/utils/services";

let apiUrl = environmentService.apiUrlHotel;
let apiUrlRates = environmentService.apiUrlRatePlan;
let headers = {headers: userService.authHeader()};

export const inventoryService = {
  searchInventory,
  createOrEditInventory,
  showRoomstype,
};


async function searchInventory (searchInventory) {
  return await postRequestHandler(`${apiUrl}/hotels/inventory`, searchInventory, headers);
}
async function showRoomstype(hotelIds){
  return await postRequestHandler(`${apiUrl}/hotels/roomtypes`, hotelIds, headers);
}

async function createOrEditInventory(NewInventory){
  return await postRequestHandler(`${apiUrl}/hotels/inventory/create`,NewInventory,headers);
}



// WEBPACK FOOTER //
// ./src/utils/services/inventory/inventory.service.js